type LogoProps = {
  size?: number;
  variant?: "mark" | "tile";
  title?: string;
};

const BUBBLE =
  "M32 8C17.6 8 6 17.4 6 29c0 6 3.1 11.4 8 15.2L11.5 56l11.7-5.8c2.8.8 5.7 1.2 8.8 1.2 14.4 0 26-9.4 26-21S46.4 8 32 8z";
const FLAME =
  "M32.6 13C36 17.6 42 22.4 42 31.5a10 10 0 0 1-20 0c0-4.8 2.4-8.3 4.8-11.6.7 2.6 1.9 4.4 3.7 5.6-.8-4.6-.3-8.8 2.1-12.5z";
const CORE = "M32 28c2.6 2.8 4.2 4.8 4.2 7.2a4.2 4.2 0 0 1-8.4 0c0-2.4 1.6-4.4 4.2-7.2z";

export function Logo({ size = 32, variant = "mark", title = "Rhema" }: LogoProps) {
  const tile = variant === "tile";
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label={title}>
      {tile && <rect width="64" height="64" rx="14" fill="#24418A" />}
      <path d={BUBBLE} fill={tile ? "#F8F7F3" : "#24418A"} />
      <path d={FLAME} fill="#E3A93C" />
      <path d={CORE} fill={tile ? "#24418A" : "#F8F7F3"} />
    </svg>
  );
}
